<script lang="ts" setup>
import { computed, ref } from "vue";
import { PButton } from "@profeat/ui-kit";

import { useBroadcast } from "~/stores/broadcast.store";
import { useChannels } from "~/stores/channel.store";
import { ChannelState } from "~/entities/channel";

const broadcastStore = useBroadcast();
const channelsStore = useChannels();

const previewSendModalOpened = ref(false);

const isValid = computed(() => {
  return (
    !!broadcastStore.getSelectedTemplate &&
    channelsStore.selectedWabaChannel?.state === ChannelState.active
  );
});

function onPreviewSendModalOpen() {
  previewSendModalOpened.value = true;
}

function onPreviewSendModalClose() {
  previewSendModalOpened.value = false;
}

function onPreviewSendModalSend(phone: string) {
  broadcastStore.sendPreviewMsg(phone)
    .then((res) => {
      if (!res) onPreviewSendModalClose();
    })
}

</script>

<template>
  <div class="message-test">
    <ModalSendPreviewMessage
      :is-opened="previewSendModalOpened"
      @close="() => onPreviewSendModalClose()"
      @send="(phone: string) => onPreviewSendModalSend(phone)"
    />

    <p class="title">{{ $t("broadcast.modal.previewSend.title") }}</p>
    <p class="description">{{ $t("broadcast.previewForm.subtitle") }}</p>

    <PButton color="secondary" @click="onPreviewSendModalOpen" :disabled="!isValid">
      {{ $t("broadcast.previewForm.sendSelf") }}
    </PButton>
  </div>
</template>

<style lang="scss" scoped>
.message-test {
  border-radius: 16px;
  border: 1px dashed var(--common-rain);
  background: var(--common-white);
  padding: 16px;

  .title {
    color: var(--common-black);
    font-size: 16px;
    font-weight: 600;
    line-height: 150%;
    margin-bottom: 12px;
  }

  .description {
    color: var(--common-black);
    font-size: 14px;
    font-weight: 400;
    line-height: 142%;
    margin-bottom: 16px;
  }
}
</style>
